export default [
    {
        label: "General Lights",
        value: "LIGHT",
        icon: "icon-C-01-01",
        icons: [
            {
                icon: "icon-C-01-01",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-01-02",
                tags: ["LIGHT", "GENERAL", "DARK"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-01-03",
                tags: ["LIGHT", "PLUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-01-04",
                tags: ["LIGHT", "MINUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-C-01-05",
                tags: ["LIGHT", "GENERAL", "SUN", "ALL"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-03-17",
                tags: ["LIGHT", "GENERAL", "OFF", "SUN"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-03-18",
                tags: ["LIGHT", "GENERAL", "ON", "SUN"],
                position: {
                    row: 1,
                    column: 7,
                },
            },

            {
                icon: "icon-C-01-06",
                tags: ["LIGHT", "GENERAL", "WALL", "SUN"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-C-01-07",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-C-01-08",
                tags: ["LIGHT", "GENERAL", "STAIRCASE", "SUN"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-C-01-12",
                tags: ["LIGHT", "WARDROBE", "SUN", "GENERAL"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-C-01-11",
                tags: ["LIGHT", "GENERAL", "SUN", "KITCHEN"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-C-01-10",
                tags: ["LIGHT", "GENERAL", "BED", "SUN"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-C-01-09",
                tags: ["LIGHT", "GENERAL", "BATHROOM", "SUN"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-C-02-03",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-D-23-08",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-23-09",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 17,
                },
            },
            {
                icon: "icon-D-23-10",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 18,
                },
            },
            {
                icon: "icon-D-01-01",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-01-02",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-01-03",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-01-04",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-01-05",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-01-06",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-01-07",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-D-01-08",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-D-01-12",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 9,
                },
            },
            {
                icon: "icon-D-01-13",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-01-14",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-01-15",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-01-16",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-01-17",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-01-18",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-D-01-20",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 7,
                },
            },
            {
                icon: "icon-D-01-09",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-D-01-10",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-C-02-06",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-C-02-07",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-D-01-11",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 5,
                },
            },
            {
                icon: "icon-D-02-07",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 6,
                },
            },
            {
                icon: "icon-D-02-06",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 7,
                },
            },
            {
                icon: "icon-D-02-05",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 8,
                },
            },
            {
                icon: "icon-D-02-02",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 9,
                },
            },
            {
                icon: "icon-D-02-03",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 10,
                },
            },
            {
                icon: "icon-D-02-04",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 11,
                },
            },
            {
                icon: "icon-D-02-08",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 12,
                },
            },
            {
                icon: "icon-D-02-09",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 13,
                },
            },
            {
                icon: "icon-D-02-10",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 14,
                },
            },
            {
                icon: "icon-D-30-01",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 15,
                },
            },
            {
                icon: "icon-D-30-02",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 16,
                },
            },
            {
                icon: "icon-D-30-03",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 17,
                },
            },
            {
                icon: "icon-D-30-04",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 18,
                },
            },
            {
                icon: "icon-C-02-04",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 1,
                },
            },
            {
                icon: "icon-D-01-19",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 2,
                },
            },
            {
                icon: "icon-D-02-01",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 3,
                },
            },
            {
                icon: "icon-C-02-01",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 4,
                },
            },
            {
                icon: "icon-C-02-02",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 5,
                },
            },
            {
                icon: "icon-D-02-12",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 1,
                },
            },
            {
                icon: "icon-D-02-13",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 2,
                },
            },
            {
                icon: "icon-D-02-14",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 3,
                },
            },
            {
                icon: "icon-D-02-15",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 4,
                },
            },
            {
                icon: "icon-D-02-16",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 5,
                },
            },
            {
                icon: "icon-D-02-17",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 6,
                },
            },
            {
                icon: "icon-D-02-18",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 7,
                },
            },
            {
                icon: "icon-D-02-19",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 8,
                },
            },
            {
                icon: "icon-D-02-20",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 9,
                },
            },
            {
                icon: "icon-D-03-01",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 10,
                },
            },
            {
                icon: "icon-D-03-02",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 11,
                },
            },
            {
                icon: "icon-D-03-03",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 12,
                },
            },
            {
                icon: "icon-D-03-04",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 13,
                },
            },
            {
                icon: "icon-D-03-05",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 14,
                },
            },
            {
                icon: "icon-D-03-06",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 15,
                },
            },
            {
                icon: "icon-D-03-07",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 16,
                },
            },
            {
                icon: "icon-D-03-08",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 1,
                },
            },
            {
                icon: "icon-D-03-09",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 2,
                },
            },
            {
                icon: "icon-D-03-10",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 3,
                },
            },
            {
                icon: "icon-D-03-11",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 4,
                },
            },
            {
                icon: "icon-D-03-12",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 5,
                },
            },
            {
                icon: "icon-D-03-13",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 6,
                },
            },
            {
                icon: "icon-D-03-14",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 7,
                },
            },
            {
                icon: "icon-D-03-15",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 8,
                },
            },
            {
                icon: "icon-D-03-16",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 9,
                },
            },
            {
                icon: "icon-d-C-12-01",
                tags: ["LIGHT", "GENERAL", "DIMMING", "SUN", "DARK", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 1,
                },
            },
            {
                icon: "icon-d-C-12-02",
                tags: ["LIGHT", "GENERAL", "DIMMING", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-13-01",
                tags: ["LIGHT", "GENERAL", "ARROW", "SUN", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 3,
                },
            },
            {
                icon: "icon-d-C-14-02",
                tags: ["LIGHT", "GENERAL", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 4,
                },
            },
            {
                icon: "icon-d-C-14-08",
                tags: ["LIGHT", "GENERAL", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 5,
                },
            },
            {
                icon: "icon-d-C-13-02",
                tags: ["LIGHT", "GENERAL", "ARROW", "LIGHTBULB", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 6,
                },
            },
            {
                icon: "icon-d-C-14-03",
                tags: ["LIGHT", "GENERAL", "LIGHTBULB", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 7,
                },
            },
            {
                icon: "icon-d-C-14-09",
                tags: ["LIGHT", "GENERAL", "LIGHTBULB", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 8,
                    column: 8,
                },
            },

            {
                icon: "icon-C-11-01",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 9,
                    column: 1,
                },
            },
            {
                icon: "icon-C-10-01",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 9,
                    column: 2,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 9,
                    column: 3,
                },
            },
            {
                icon: "icon-C-11-11",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 9,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-12",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 9,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 9,
                    column: 6,
                },
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 9,
                    column: 7,
                },
            },
            {
                icon: "icon-C-11-03",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 9,
                    column: 8,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 9,
                    column: 9,
                },
            },
        ],
    },
    {
        label: "Hotel",
        value: "HOTEL",
        icon: "icon-D-22-01",
        icons: [
            {
                icon: "icon-C-05-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-05-02",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-08-02",
                tags: ["HOTEL", "HOSPITALITY", "MUR", "ROOM"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-08-01",
                tags: ["HOTEL", "HOSPITALITY", "STAFF", "ROOM"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-C-08-03",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-22-15",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-22-16",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-22-17",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-22-02",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-22-03",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-C-07-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-22-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "REGISTRATION"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-19-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LIFT"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-19-02",
                tags: ["HOTEL", "HOSPITALITY", "PAY"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-23-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "WI-FI"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-C-05-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-22-04",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "CONFERENCE"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-C-07-03",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-D-22-05",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-D-22-06",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-D-22-13",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-D-22-14",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 5,
                },
            },
            {
                icon: "icon-D-22-08",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 6,
                },
            },
            {
                icon: "icon-D-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 1,
                },
            },
            {
                icon: "icon-D-22-12",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 2,
                },
            },
            {
                icon: "icon-D-22-07",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 3,
                },
            },
            {
                icon: "icon-D-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 5,
                    column: 4,
                },
            },
            {
                icon: "icon-D-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 5,
                },
            },
            {
                icon: "icon-D-22-09",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 1,
                },
            },
            {
                icon: "icon-D-22-10",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 2,
                },
            },
            {
                icon: "icon-D-22-18",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED", "SOFA"],
                position: {
                    row: 6,
                    column: 3,
                },
            },
        ],
    },
    {
        label: "Interface",
        value: "INTERFACE",
        icon: "icon-C-11-01",
        icons: [
            {
                icon: "icon-C-11-01",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-11-12",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-11-11",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-03",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-C-11-16",
                tags: ["INTERFACE", "CANCEL", "CONTROL"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-C-11-17",
                tags: ["INTERFACE", "OK", "CONTROL"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-23-01",
                tags: ["INTERFACE", "SETTINGS", "CONTROL"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-23-02",
                tags: ["INTERFACE", "SETTINGS", "CONTROL"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-23-07",
                tags: ["INTERFACE", "CONTROL"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-C-10-02",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-C-10-01",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-C-10-03",
                tags: ["INTERFACE", "WORD", "AUTO", "CONTROL"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-C-10-04",
                tags: ["INTERFACE", "WORD", "MODE", "CONTROL"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-C-10-05",
                tags: ["INTERFACE", "WORD", "INPUT", "CONTROL"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-C-10-06",
                tags: ["INTERFACE", "WORD", "UP", "CONTROL"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-C-10-07",
                tags: ["INTERFACE", "WORD", "DOWN", "CONTROL"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-C-10-08",
                tags: ["INTERFACE", "WORD", "OPEN", "CONTROL"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-C-10-09",
                tags: ["INTERFACE", "WORD", "CLOSE", "CONTROL"],
                position: {
                    row: 2,
                    column: 9,
                },
            },
            {
                icon: "icon-C-10-10",
                tags: ["INTERFACE", "WORD", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 10,
                },
            },
            {
                icon: "icon-C-10-11",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 11,
                },
            },
            {
                icon: "icon-C-10-12",
                tags: [
                    "INTERFACE",
                    "WORD",
                    "FAHRENHEIT",
                    "CELSIUM",
                    "TEMPERATURE",
                    "CONTROL",
                ],
                position: {
                    row: 2,
                    column: 12,
                },
            },
            {
                icon: "icon-C-10-13",
                tags: ["INTERFACE", "WORD", "OK", "CONTROL"],
                position: {
                    row: 2,
                    column: 13,
                },
            },
            {
                icon: "icon-D-23-03",
                tags: ["INTERFACE", "WORD", "SOS", "CONTROL"],
                position: {
                    row: 2,
                    column: 14,
                },
            },
            {
                icon: "icon-D-23-04",
                tags: ["INTERFACE", "WORD", "NEW", "CONTROL"],
                position: {
                    row: 2,
                    column: 15,
                },
            },
            {
                icon: "icon-D-23-05",
                tags: ["INTERFACE", "WORD", "SET", "CONTROL"],
                position: {
                    row: 2,
                    column: 16,
                },
            },
            {
                icon: "icon-d-C-15-01",
                tags: ["INTERFACE", "WORD", "ON", "OFF", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-d-C-15-02",
                tags: ["INTERFACE", "WORD", "UP", "DOWN", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-15-03",
                tags: ["INTERFACE", "WORD", "OPEN", "CLOSE", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-d-C-15-04",
                tags: ["INTERFACE", "WORD", "HVAC", "CLIMA", "FAHRENHEITE", "CELSIUM", "TEMPERATURE", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-d-C-15-05",
                tags: ["INTERFACE", "WORD", "HVAC", "CLIMA", "FAHRENHEIT", "CELSIUM", "TEMPERATURE", "MODE", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-d-C-13-07",
                tags: ["INTERFACE", "ARROW", "OPEN", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-d-C-13-08",
                tags: ["INTERFACE", "ARROW", "OPEN", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 7,
                },
            },
            {
                icon: "icon-d-C-13-09",
                tags: ["INTERFACE", "ARROW", "UP", "DOWN", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 8,
                },
            },
            {
                icon: "icon-d-C-13-10",
                tags: ["INTERFACE", "ARROW", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 9,
                },
            },
        ],
    },
    {
        label: "Scene",
        value: "SCENE",
        icon: "icon-C-06-01",
        icons: [
            {
                icon: "icon-C-06-03",
                tags: ["SCENE", "MOON", "DARK", "MOOD"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-06-04",
                tags: ["SCENE", "MORNING", "MOOD"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-06-02",
                tags: ["SCENE", "MOOD", "RELAX", "DRINKS"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-06-01",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-15-13",
                tags: ["SCENE", "PILLOW", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-15-14",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-15-12",
                tags: ["SCENE", "HEART", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-15-18",
                tags: ["SCENE", "HEART", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-15-16",
                tags: ["SCENE", "MOOD", "PAINT", "DRAWING", "RELAX"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-24-01",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-24-02",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-24-05",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-d-C-12-08",
                tags: ["SCENE", "MOOON", "MORNING", "EVENING", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
        ],
    },
    {
        label: "Sheers",
        value: "BLIND",
        icon: "icon-D-07-07",
        icons: [
            {
                icon: "icon-C-03-01",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-03-02",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-03-03",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-07-11",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-07-06",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-07-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-07-10",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-07-09",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-07-07",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-07-01",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-07-05",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-C-03-05",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-C-03-06",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-C-03-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-07-08",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-07-02",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-07-03",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-07-12",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-d-C-12-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-d-C-12-05",
                tags: ["BLIND", "BLACKOUT", "SHEERS", "ARROW", "CURTAINS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-13-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-d-C-13-05",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "ARROW", "SHEERS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-25-11",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-D-25-12",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-D-25-13",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-D-25-14",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-11",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 1,
                },
            },
            {
                icon: "icon-C-11-12",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 2,
                },
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 5,
                    column: 3,
                },
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 5,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-03",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 6,
                },
            },
        ],
    },
    {
        label: "Window/Door",
        value: "DOOR",
        icon: "icon-C-02-05",
        icons: [
            {
                icon: "icon-D-08-01",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-08-02",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-08-03",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-08-04",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-08-05",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-08-06",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-08-07",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-08-08",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-08-09",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-C-02-05",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-08-10",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-08-11",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-08-12",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-08-13",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-08-14",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-08-15",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-D-08-16",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-D-09-01",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-09-02",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-09-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-09-04",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-09-05",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-09-06",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-D-09-07",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 7,
                },
            },
            {
                icon: "icon-D-09-11",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 8,
                },
            },
            {
                icon: "icon-C-05-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 9,
                },
            },
            {
                icon: "icon-D-25-01",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-D-25-02",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-D-25-03",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-D-25-04",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-D-25-05",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 5,
                },
            },
            {
                icon: "icon-D-25-06",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 6,
                },
            },
            {
                icon: "icon-D-25-07",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 7,
                },
            },
            {
                icon: "icon-D-25-08",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 8,
                },
            },
            {
                icon: "icon-D-25-09",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 9,
                },
            },
            {
                icon: "icon-D-25-10",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 10,
                },
            },
        ],
    },
    {
        label: "HVAC",
        value: "HVAC",
        icon: "icon-C-04-07",
        icons: [
            {
                icon: "icon-C-04-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-C-04-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-04-07",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-04-01",
                tags: ["HVAC", "CLIMA", "CONTROL", "TEMPERATURE"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-C-04-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "COOLING"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-C-04-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "HEATING"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-C-04-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "ECO"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-13-01",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-13-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-13-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-13-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-13-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-13-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-D-26-01",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-26-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-D-26-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-26-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 17,
                },
            },
            {
                icon: "icon-D-26-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 18,
                },
            },
            {
                icon: "icon-D-26-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 19,
                },
            },
            {
                icon: "icon-D-13-07",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-13-08",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-13-09",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-13-10",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-13-11",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-19-16",
                tags: ["HVAC", "CLIMA", "HEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-19-17",
                tags: ["HVAC", "CLIMA", "COOLING", "CONTROL"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-D-19-18",
                tags: ["HVAC", "CLIMA", "FLOORHEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-D-19-19",
                tags: ["HVAC", "CLIMA", "FLOORHEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 9,
                },
            },
            {
                icon: "icon-D-21-05",
                tags: ["HVAC", "CLIMA", "SIGNS", "COOLING", "CONTROL"],
                position: {
                    row: 2,
                    column: 10,
                },
            },
            {
                icon: "icon-D-21-06",
                tags: ["HVAC", "CLIMA", "SIGNS", "HEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 11,
                },
            },
            {
                icon: "icon-D-13-12",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-13-13",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-13-14",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-13-15",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-13-16",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-13-17",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-D-26-07",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 7,
                },
            },
            {
                icon: "icon-D-26-08",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 8,
                },
            },
            {
                icon: "icon-d-C-12-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "TEMPERATURE", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-d-C-13-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "ARROW", "TEMPERATURE", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-14-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "PLUS", "MINUS", "TEMPERATURE", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-d-C-14-10",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "PLUS", "MINUS", "TEMPERATURE", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-d-C-14-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 5,
                },
            },
            {
                icon: "icon-d-C-14-12",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 6,
                },
            },
            {
                icon: "icon-d-C-15-04",
                tags: ["INTERFACE", "HVAC", "CLIMA", "WORD", "FAHRENGATE", "CELSIUM", "TEMPERATURE", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 7,
                },
            },
            {
                icon: "icon-d-C-15-05",
                tags: ["INTERFACE", "HVAC", "CLIMA", "WORD", "FAHRENGATE", "CELSIUM", "TEMPERATURE", "MODE", "CONTROL", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 4,
                    column: 8,
                },
            },

            {
                icon: "icon-C-11-01",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 5,
                    column: 1,
                },
            },
            {
                icon: "icon-C-11-11",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 2,
                },
            },
            {
                icon: "icon-C-11-12",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 3,
                },
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 5,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 5,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-03",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 6,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 7,
                },
            },
            {
                icon: "icon-C-10-02",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 5,
                    column: 8,
                },
            },
            {
                icon: "icon-C-10-01",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 5,
                    column: 9,
                },
            },
            {
                icon: "icon-C-10-03",
                tags: ["INTERFACE", "WORD", "AUTO", "CONTROL"],
                position: {
                    row: 5,
                    column: 10,
                },
            },
            {
                icon: "icon-C-10-04",
                tags: ["INTERFACE", "WORD", "MODE", "CONTROL"],
                position: {
                    row: 5,
                    column: 11,
                },
            },
            {
                icon: "icon-C-10-10",
                tags: ["INTERFACE", "WORD", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 5,
                    column: 12,
                },
            },
            {
                icon: "icon-C-10-11",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 5,
                    column: 13,
                },
            },
        ],
    },
    {
        label: "Media",
        value: "MEDIA",
        icon: "icon-C-09-04",
        icons: [
            {
                icon: "icon-C-09-04",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-16-09",
                tags: ["MEDIA", "AV", "CINEMA", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-C-09-01",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-C-09-02",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-C-09-03",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-04",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-C-11-05",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-C-11-06",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-C-11-07",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-C-11-08",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-C-11-09",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-C-11-10",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-16-06",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-C-11-15",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-16-01",
                tags: ["MEDIA", "CINEMA", "MUSIC", "AUDIO"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-D-16-02",
                tags: ["MEDIA", "CINEMA", "MUSIC", "AUDIO"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-16-17",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "HEADPHONES"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-16-04",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "HEADPHONES"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-16-03",
                tags: [
                    "MEDIA",
                    "AV",
                    "MUSIC",
                    "SPEAKERS",
                    "KARAOKE",
                    "AUDIO",
                    "MICROPHONE",
                ],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-16-05",
                tags: [
                    "MEDIA",
                    "AV",
                    "MUSIC",
                    "SPEAKERS",
                    "KARAOKE",
                    "AUDIO",
                    "MICROPHONE",
                ],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-16-14",
                tags: [
                    "MEDIA",
                    "AV",
                    "CINEMA",
                    "MUSIC",
                    "KARAOKE",
                    "AUDIO",
                    "SPEAKERS",
                ],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-16-15",
                tags: [
                    "MEDIA",
                    "AV",
                    "CINEMA",
                    "MUSIC",
                    "KARAOKE",
                    "AUDIO",
                    "SPEAKERS",
                ],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-16-16",
                tags: [
                    "MEDIA",
                    "AV",
                    "CINEMA",
                    "MUSIC",
                    "KARAOKE",
                    "AUDIO",
                    "SPEAKERS",
                ],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-C-07-02",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-16-07",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-16-08",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-16-10",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-16-11",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-16-12",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 6,
                },
            },
            {
                icon: "icon-D-16-13",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 7,
                },
            },
            {
                icon: "icon-D-16-18",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 8,
                },
            },
            {
                icon: "icon-D-16-19",
                tags: ["MEDIA", "CINEMA", "VIDEO", "CAMERA", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 9,
                },
            },
            {
                icon: "icon-D-17-05",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 10,
                },
            },
            {
                icon: "icon-D-17-06",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 11,
                },
            },
            {
                icon: "icon-D-17-07",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 12,
                },
            },
            {
                icon: "icon-D-17-08",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 13,
                },
            },
            {
                icon: "icon-D-17-09",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 14,
                },
            },
            {
                icon: "icon-D-17-10",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 15,
                },
            },
            {
                icon: "icon-D-17-11",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "PROJECTOR", "TV"],
                position: {
                    row: 3,
                    column: 16,
                },
            },
            {
                icon: "icon-D-17-03",
                tags: ["CINEMA", "FOOD"],
                position: {
                    row: 4,
                    column: 1,
                },
            },

            {
                icon: "icon-D-17-04",
                tags: ["CINEMA", "DRINKS"],
                position: {
                    row: 4,
                    column: 2,
                },
            },

            {
                icon: "icon-D-17-02",
                tags: ["CINEMA", "GLASSES"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-D-17-01",
                tags: ["MEDIA", "CINEMA", "CONFERENCE", "KARAOKE", "TV"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
            {
                icon: "icon-D-16-20",
                tags: ["MEDIA", "CINEMA", "CONFERENCE", "KARAOKE", "TV"],
                position: {
                    row: 4,
                    column: 5,
                },
            },

            {
                icon: "icon-C-09-06",
                tags: ["MEDIA", "BLUETOOTH"],
                position: {
                    row: 5,
                    column: 1,
                },
            },
            {
                icon: "icon-C-09-05",
                tags: ["MEDIA", "USB"],
                position: {
                    row: 5,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-13-06",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE", "ARROW"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 6,
                    column: 1,
                },
            },
            {
                icon: "icon-d-C-14-05",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 6,
                    column: 2,
                },
            },
            {
                icon: "icon-d-C-14-11",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 6,
                    column: 3,
                },
            },
            {
                icon: "icon-d-C-12-06",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 6,
                    column: 4,
                },
            },
            {
                icon: "icon-d-C-12-07",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE"],
                series: ["alba", "blackjack|rectangle"],
                position: {
                    row: 6,
                    column: 5,
                },
            },

            {
                icon: "icon-C-11-01",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 7,
                    column: 1,
                },
            },
            {
                icon: "icon-C-11-11",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 7,
                    column: 2,
                },
            },
            {
                icon: "icon-C-11-12",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 7,
                    column: 3,
                },
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 7,
                    column: 4,
                },
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 7,
                    column: 5,
                },
            },
            {
                icon: "icon-C-11-03",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 7,
                    column: 6,
                },
            },
            {
                icon: "icon-C-11-02",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 7,
                    column: 7,
                },
            },
        ],
    },
    {
        label: "Kitchen",
        value: "KITCHEN",
        icon: "icon-D-04-12",
        icons: [
            {
                icon: "icon-D-04-01",
                tags: ["KITCHEN", "APPLIANCE", "KETTLE"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-04-13",
                tags: ["KITCHEN", "APPLIANCE", "KETTLE"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-04-02",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-04-04",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-04-03",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-04-05",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-04-06",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-04-07",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-04-08",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-04-09",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-04-10",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "COFE", "EAT"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-04-11",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-04-12",
                tags: ["KITCHEN", "RESTAURANT", "EAT", "DINING", "FORK", "SPOON"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-D-04-14",
                tags: ["KITCHEN", "DRINKS", "RESTAURANT"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-04-15",
                tags: ["KITCHEN", "CANDLES", "RESTAURANT"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-D-04-16",
                tags: ["KITCHEN", "BAR"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-04-17",
                tags: ["KITCHEN", "KITCHEN ISLAND"],
                position: {
                    row: 1,
                    column: 17,
                },
            },
        ],
    },
    {
        label: "Bathroom",
        value: "BATHROOM",
        icon: "icon-D-05-16",
        icons: [
            {
                icon: "icon-D-05-10",
                tags: ["BATHROOM", "TOILET"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-05-11",
                tags: ["BATHROOM", "TOILET"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-05-12",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-05-13",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-05-14",
                tags: ["BATHROOM", "WASHBASIN", "SHOWER"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-05-15",
                tags: ["BATHROOM", "WASHBASIN", "SHOWER"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-05-16",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-22-12",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-22-07",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-05-01",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-05-02",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-05-03",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-05-04",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-05-05",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-05-06",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-05-07",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-D-05-08",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-D-05-09",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 9,
                },
            },
            {
                icon: "icon-D-05-17",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 10,
                },
            },
            {
                icon: "icon-D-06-01",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-06-02",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-06-03",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-06-04",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-06-05",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
        ],
    },
    {
        label: "Garden",
        value: "GARDEN",
        icon: "icon-D-11-10",
        icons: [
            {
                icon: "icon-D-11-13",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-11-10",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-11-11",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-11-12",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-11-14",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-11-15",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-11-16",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-11-17",
                tags: ["OUTDOOR", "GREEN", "RELAX", "SPA"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-11-18",
                tags: ["OUTDOOR", "GREEN", "MOUNTAINS"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-06-06",
                tags: ["ENVIRONMENT", "RECYCLING", "GREEN"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-06-07",
                tags: ["ENVIRONMENT", "TRASH", "BASCKET"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-23-06",
                tags: ["ENVIRONMENT", "RECYCLING", "GREEN"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
        ],
    },
    {
        label: "Security",
        value: "SECURITY",
        icon: "icon-D-09-08",
        icons: [
            {
                icon: "icon-D-09-08",
                tags: ["SECURITY", "DOOR", "DOORLOCK"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-09-13",
                tags: ["SECURITY", "DOORLOCK", "LOCK"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-09-14",
                tags: ["SECURITY", "DOORLOCK", "LOCK", "UNLOCK"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-09-15",
                tags: ["SECURITY"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-09-16",
                tags: ["SECURITY"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-09-17",
                tags: ["SECURITY", "DOORLOCK", "LOCK", "KEYPAD"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-09-18",
                tags: ["SECURITY", "IMPRINT", "LOCK", "UNLOCK"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-09-01",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-09-02",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-09-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-09-04",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-09-05",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-09-06",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-D-09-07",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-09-11",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-C-05-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-21-01",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-21-07",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-21-08",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-21-09",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-21-10",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-21-11",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-21-12",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 7,
                },
            },
            {
                icon: "icon-D-21-13",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 8,
                },
            },
            {
                icon: "icon-D-21-14",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 9,
                },
            },
            {
                icon: "icon-D-21-15",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 10,
                },
            },
            {
                icon: "icon-D-09-09",
                tags: ["SECURITY", "ALARM", "BELL"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-09-10",
                tags: ["SECURITY", "ALARM", "BELL"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-09-12",
                tags: ["SECURITY", "ALARM", "BELL", "SOS"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-21-02",
                tags: ["SECURITY", "ALARM"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
        ],
    },
    {
        label: "Office",
        value: "OFFICE",
        icon: "icon-D-10-01",
        icons: [
            {
                icon: "icon-D-10-01",
                tags: ["OFFICE", "IT", "NETWORK", "COMPUTER", "LAPTOP"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-10-02",
                tags: ["OFFICE", "IT", "PRINTER", "NETWORK"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-10-03",
                tags: ["OFFICE", "IT", "CAMERA", "NETWORK"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-10-04",
                tags: ["OFFICE", "IT", "MONITOR", "NETWORK", "COMPUTER"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-10-05",
                tags: ["OFFICE", "IT", "PHONE", "NETWORK"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-10-06",
                tags: ["OFFICE", "IT", "NETWORK", "GAME"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-10-07",
                tags: ["OFFICE", "IT", "NETWORK", "COMPUTER", "MONITOR"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-10-11",
                tags: ["OFFICE", "IT", "NETWORK"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
        ],
    },
    {
        label: "Accessories",
        value: "ACCESSORIES",
        icon: "icon-D-15-06",
        icons: [
            {
                icon: "icon-D-10-08",
                tags: [
                    "ACCESSORIES",
                    "TIME",
                    "CLOCK",
                    "DISPLAY",
                    "DECORATION",
                    "FURNITURE",
                ],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-10-09",
                tags: [
                    "ACCESSORIES",
                    "TIME",
                    "CLOCK",
                    "DISPLAY",
                    "DECORATION",
                    "FURNITURE",
                ],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-10-10",
                tags: ["ACCESSORIES", "FURNITURE"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-15-06",
                tags: ["ACCESSORIES", "DECORATION", "VASE", "FURNITURE"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-15-07",
                tags: ["ACCESSORIES", "MIRROR", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-15-08",
                tags: ["ACCESSORIES", "MIRROR", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-15-09",
                tags: ["ACCESSORIES", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-15-10",
                tags: ["ACCESSORIES", "DECORATION", "VASE", "FURNITURE"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-15-11",
                tags: ["ACCESSORIES", "DECORATION", "CARPET", "FURNITURE"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1,
                },
            },
            {
                icon: "icon-D-24-01",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2,
                },
            },
            {
                icon: "icon-D-24-02",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3,
                },
            },
            {
                icon: "icon-D-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 4,
                },
            },
            {
                icon: "icon-D-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 5,
                },
            },
            {
                icon: "icon-D-24-05",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 6,
                },
            },
            {
                icon: "icon-D-29-01",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 1,
                },
            },
            {
                icon: "icon-D-29-02",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 2,
                },
            },
            {
                icon: "icon-D-29-03",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 3,
                },
            },
            {
                icon: "icon-D-29-04",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 4,
                },
            },
            {
                icon: "icon-D-29-05",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 5,
                },
            },
            {
                icon: "icon-D-06-08",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 1,
                },
            },
            {
                icon: "icon-D-06-09",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 2,
                },
            },
            {
                icon: "icon-D-06-10",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 3,
                },
            },
            {
                icon: "icon-D-06-11",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 4,
                },
            },
        ],
    },
    {
        label: "Fireplace",
        value: "FIREPLACE",
        icon: "icon-D-11-04",
        icons: [
            {
                icon: "icon-D-11-01",
                tags: ["FIREPLACE", "STOVE", "FIRE", "WOOD"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-11-02",
                tags: ["FIREPLACE", "STOVE", "FIRE", "WOOD"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-11-03",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-11-04",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-11-05",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-11-06",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-11-07",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-11-08",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-11-09",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-11-19",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
        ],
    },
    {
        label: "Garage",
        value: "GARAGE",
        icon: "icon-D-12-06",
        icons: [
            {
                icon: "icon-D-12-01",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-12-02",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-12-03",
                tags: ["GARAGE", "CAR"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-12-04",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-12-05",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-12-06",
                tags: ["GARAGE", "CAR"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-12-07",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-12-08",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-12-09",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-12-10",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-12-11",
                tags: ["TRAFFIC LIGHTS"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
        ],
    },
    {
        label: "Clima",
        value: "CLIMA",
        icon: "icon-D-13-17",
        icons: [
            {
                icon: "icon-D-19-03",
                tags: ["CLIMA", "TECHNICAL", "FURNACE"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-19-04",
                tags: ["CLIMA", "TECHNICAL", "PUMP"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-19-05",
                tags: ["CLIMA", "TECHNICAL", "PUMP"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-19-06",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-19-07",
                tags: ["CLIMA", "TECHNICAL", "FLOORHEATING"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-19-08",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "FURNACE"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-19-09",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "FURNACE"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-19-10",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "BOILER", "FURNACE"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-19-11",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-19-12",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-19-13",
                tags: ["CLIMA", "TECHNICAL", "FLOORHEATING"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-19-14",
                tags: ["CLIMA", "TECHNICAL", "CONTROL", "KEYPAD"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-19-15",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-D-21-03",
                tags: ["CLIMA", "TECHNICAL", "SIGNS"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-21-04",
                tags: ["CLIMA", "TECHNICAL", "SIGNS"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
        ],
    },
    {
        label: "Relax",
        value: "SPA",
        icon: "icon-D-14-01",
        icons: [
            {
                icon: "icon-D-14-01",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-14-02",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-14-03",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-14-04",
                tags: ["SPA", "SAUNA", "RELAX", "SWIMING"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-14-05",
                tags: ["SPA", "SAUNA", "RELAX"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-14-06",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-14-07",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-14-08",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-14-09",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-14-10",
                tags: ["SPA", "RELAX", "MASSAGE"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-14-11",
                tags: ["RELAX", "TENNIS", "GYM"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-14-12",
                tags: ["RELAX", "GYM"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-15-15",
                tags: ["SPA", "SAUNA", "RELAX", "CANDLES"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
            {
                icon: "icon-D-11-17",
                tags: ["OUTDOOR", "GREEN", "RELAX", "SPA"],
                position: {
                    row: 1,
                    column: 14,
                },
            },
            {
                icon: "icon-D-14-13",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 15,
                },
            },
            {
                icon: "icon-D-14-14",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 16,
                },
            },
            {
                icon: "icon-D-14-15",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 17,
                },
            },
            {
                icon: "icon-D-14-16",
                tags: ["CARDIO", "GYM", "RELAX"],
                position: {
                    row: 1,
                    column: 18,
                },
            },
            {
                icon: "icon-D-14-17",
                tags: ["CARDIO", "GYM", "RELAX"],
                position: {
                    row: 1,
                    column: 19,
                },
            },
            {
                icon: "icon-D-14-18",
                tags: ["SPA", "PATIO", "RELAX"],
                position: {
                    row: 1,
                    column: 20,
                },
            },
            {
                icon: "icon-D-14-19",
                tags: ["SPA", "PATIO", "RELAX"],
                position: {
                    row: 1,
                    column: 21,
                },
            },
            {
                icon: "icon-D-14-20",
                tags: ["GOLF", "RELAX", "GYM"],
                position: {
                    row: 1,
                    column: 22,
                },
            },
        ],
    },
    {
        label: "Pet",
        value: "KID",
        icon: "icon-D-15-02",
        icons: [
            {
                icon: "icon-D-15-01",
                tags: ["KID", "TOY"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-15-02",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-15-03",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-15-04",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-15-05",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
        ],
    },
    {
        label: "Power",
        value: "BATTERY",
        icon: "icon-D-18-09",
        icons: [
            {
                icon: "icon-D-18-01",
                tags: ["POWER"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-18-02",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-18-03",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-18-04",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-18-05",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-18-06",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-18-07",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-18-08",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-18-09",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
        ],
    },
    {
        label: "Sockets",
        value: "SOCKETS",
        icon: "icon-D-20-01",
        icons: [
            {
                icon: "icon-D-20-01",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-20-02",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-20-03",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-20-04",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-20-05",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-20-06",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
        ],
    },
    {
        label: "Delivery",
        value: "Delivery",
        icon: "icon-D-28-04",
        icons: [
            {
                icon: "icon-D-28-01",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-28-02",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-28-03",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-28-04",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
        ],
    },
    {
        label: "Outdoor Heater",
        value: "Outdoor Heater",
        icon: "icon-D-27-09",
        icons: [
            {
                icon: "icon-D-27-01",
                tags: ["OUTDOOR", "HEATER"],
                position: {
                    row: 1,
                    column: 1,
                },
            },
            {
                icon: "icon-D-27-02",
                tags: ["OUTDOOR", "SOLAR PANEL"],
                position: {
                    row: 1,
                    column: 2,
                },
            },
            {
                icon: "icon-D-27-03",
                tags: ["OUTDOOR", "HEATER", "LIGHT"],
                position: {
                    row: 1,
                    column: 3,
                },
            },
            {
                icon: "icon-D-27-04",
                tags: ["OUTDOOR", "CARBON"],
                position: {
                    row: 1,
                    column: 4,
                },
            },
            {
                icon: "icon-D-27-05",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 5,
                },
            },
            {
                icon: "icon-D-27-06",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 6,
                },
            },
            {
                icon: "icon-D-27-07",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 7,
                },
            },
            {
                icon: "icon-D-27-08",
                tags: ["OUTDOOR", "HEATER"],
                position: {
                    row: 1,
                    column: 8,
                },
            },
            {
                icon: "icon-D-27-09",
                tags: ["OUTDOOR", "HEATER", "FIREPLACE"],
                position: {
                    row: 1,
                    column: 9,
                },
            },
            {
                icon: "icon-D-27-10",
                tags: ["OUTDOOR", "BBQ"],
                position: {
                    row: 1,
                    column: 10,
                },
            },
            {
                icon: "icon-D-27-11",
                tags: ["OUTDOOR", "BBQ"],
                position: {
                    row: 1,
                    column: 11,
                },
            },
            {
                icon: "icon-D-27-12",
                tags: ["OUTDOOR", "FIRE TORCH", "TEMPEST TORCH"],
                position: {
                    row: 1,
                    column: 12,
                },
            },
            {
                icon: "icon-D-27-13",
                tags: ["OUTDOOR", "HEATER", "LIGHT"],
                position: {
                    row: 1,
                    column: 13,
                },
            },
        ],
    },
];
